import { render } from "./ShipmentTracking.vue?vue&type=template&id=3d65ee3c"
import script from "./ShipmentTracking.vue?vue&type=script&lang=js"
export * from "./ShipmentTracking.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__